
import moment from 'moment'

export default {
    
    data(){
        return {
            dateFormatter: {
                longDateFormat: 'DD MMM YYYY HH:mm:ss',
            }
        }
    },
    methods: {
        // Element UI table formatter parameters
        toLongDateTime(dateTime) {
            return moment(dateTime).format(this.dateFormatter.longDateFormat);
        },
        ElTableDateFormatter(row, col, cell, index) {
            return this.toLongDateTime(cell);
        },
        diffForHumans(dateTime) {
            return moment(dateTime).fromNow();
        }
    }
}
